import 'babel-polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
// Importar y registrar componentes

import modalApp from '@/components/modal'
Vue.component("modal-app", modalApp)


Vue.config.productionTip = false

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  },
  componentUpdated: function (el) {
    // Focus the element
    el.focus()
    el.scrollIntoView({
      behavior: "smooth"
    })
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')